import * as turf from "@turf/turf";

const DrawCircleMode = {
  onSetup() {
    const center = null;

    const placeholder = [
      [0, 0],
      [0.00001, 0],
      [0.00001, 0.00001],
      [0, 0],
    ];

    const circle = this.newFeature({
      type: "Feature",
      properties: { shape: "circle" },
      geometry: {
        type: "Polygon",
        coordinates: [placeholder],
      },
    });

    // Radius handle (Point)
    const handle = this.newFeature({
      type: "Feature",
      properties: { meta: "radius_handle" },
      geometry: {
        type: "Point",
        coordinates: [0, 0],
      },
    });

    this.addFeature(circle);
    this.addFeature(handle);

    this.clearSelectedFeatures();
    this.updateUIClasses({ mouse: "add" });

    return {
      circle,
      handle,
      center,
      radius: 0,
      draggingHandle: false,
    };
  },

  onClick(state, e) {
    if (!state.center) {
      state.center = [e.lngLat.lng, e.lngLat.lat];
      state.circle.setCoordinates([[state.center]]);
      return;
    }

    // second click creates initial circle
    const edge = [e.lngLat.lng, e.lngLat.lat];
    state.radius = turf.distance(turf.point(state.center), turf.point(edge), {
      units: "kilometers",
    });

    this._updateCircle(state);

    this.changeMode("simple_select", {
      featureIds: [state.circle.id, state.handle.id],
    });
  },

  onMouseDown(state, e) {
    if (e.featureTarget?.properties?.meta === "radius_handle") {
      state.draggingHandle = true;
      e.preventDefault();
    }
  },

  onMouseMove(state, e) {
    if (!state.draggingHandle) return;

    state.radius = turf.distance(
      turf.point(state.center),
      turf.point([e.lngLat.lng, e.lngLat.lat]),
      { units: "kilometers" }
    );

    this._updateCircle(state);
  },

  onMouseUp(state) {
    state.draggingHandle = false;
  },

  _updateCircle(state) {
    const poly = turf.circle(state.center, state.radius, { steps: 64 });
    state.circle.setCoordinates(poly.geometry.coordinates);

    // place handle on east edge
    const edge = turf.destination(turf.point(state.center), state.radius, 90, {
      units: "kilometers",
    });

    state.handle.setCoordinates(edge.geometry.coordinates);
  },

  toDisplayFeatures(state, geojson, display) {
    geojson.properties.active = "true";
    display(geojson);
  },
};

export default DrawCircleMode;
